import styled from 'styled-components'
import { useRouter } from 'next/router'

import { trpc } from '~/utils/trpc'

import DefaultLayout from 'components/core/layout/DefaultLayout'
import { HeaderSpacerNoMobile } from 'components/core/header/Header'
import SubmissionCard, {
  MobileButtonsDiv,
  SubmissionCardDiv,
  SubmissionCardImage,
  SubmissionCardOuterContainer,
} from 'components/submission/SubmissionCard'

import { useAccount } from 'wagmi'
import { PrimaryButton } from 'components/core/Buttons'
import SubmissionCardLeft from 'components/submission/SubmissionCardLeft'
import Link from 'next/link'
import { getDisplayNameFromGobblerAuthAccount } from 'utils/auth'

const Glow = styled.div`
  position: absolute;

  z-index: 0;

  height: 807px;
  top: -619px;

  background: linear-gradient(180deg, #6bf1fd 0%, #96ff94 100%);
  opacity: 0.7;
  filter: blur(102px);

  width: 100%;
  align-self: center;
  max-width: 1280px;

  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;

  border-radius: 40%;
`

// Submissions Header
const SubmissionsHeaderDiv = styled.div`
  z-index: 1;
  display: flex;
  align-items: center;
  align-self: center;
  gap: 24px;

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    align-self: flex-start;
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
`};
`

const BackButton = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 26px;
  font-weight: 700;
  color: #8ef42e;

  transition: transform 0.2s ease-in-out;
  &:hover {
    cursor: pointer;
    transform: scale(1.025);
  }
`

const HeaderText = styled.div`
  font-size: 42px;
  font-weight: 900;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    font-size: 32px;
  `};
`

function SubmissionsHeader({ submissionCount }: { submissionCount: number }) {
  const submissionsText = submissionCount === 1 ? 'submission' : 'Submissions'
  const { back } = useRouter()
  return (
    <SubmissionsHeaderDiv>
      <BackButton onClick={back}>
        <svg width="11" height="16" viewBox="0 0 11 16" fill="none">
          <path
            d="M7.21521 0.380662C7.30266 0.269812 7.41258 0.178735 7.53776 0.113423C7.66293 0.0481124 7.80052 0.010048 7.94146 0.00173495C8.0824 -0.00657806 8.22351 0.0150488 8.35549 0.0651924C8.48748 0.115336 8.60735 0.19286 8.70721 0.292662L10.7072 2.29266C10.8947 2.48019 11 2.7345 11 2.99966C11 3.26483 10.8947 3.51913 10.7072 3.70666L6.41421 7.99966L10.7072 12.2927C10.8947 12.4802 11 12.7345 11 12.9997C11 13.2648 10.8947 13.5191 10.7072 13.7067L8.70721 15.7067C8.51969 15.8941 8.26538 15.9994 8.00021 15.9994C7.73505 15.9994 7.48074 15.8941 7.29321 15.7067L0.293214 8.70666C0.199937 8.61375 0.125924 8.50334 0.0754223 8.38176C0.0249205 8.26017 -0.00107574 8.12982 -0.00107574 7.99816C-0.00107574 7.86651 0.0249205 7.73615 0.0754223 7.61457C0.125924 7.49299 0.199937 7.38257 0.293214 7.28966C2.88321 4.72566 6.81321 0.815662 7.21521 0.380662Z"
            fill="#8EF42E"
          />
        </svg>
        Back
      </BackButton>
      <HeaderText>
        {submissionCount} {submissionsText}
      </HeaderText>
    </SubmissionsHeaderDiv>
  )
}

const Submissions = () => {
  const { address: walletAddress } = useAccount()
  const { data: submissions } = trpc.useQuery(
    ['submissions.getUnreadSubmissions', { walletAddress: walletAddress! }],
    { enabled: !!walletAddress },
  )

  return (
    <DefaultLayout>
      <Glow />
      <HeaderSpacerNoMobile />
      <SubmissionsHeader submissionCount={submissions?.length || 0} />
      {submissions &&
        submissions.map((submission) => {
          const imgSrc = submission.drawing.base_64_image
          const drawingShortId = submission.art_drawing_short_id

          return (
            <SubmissionCardOuterContainer key={submission.art_drawing_short_id}>
              <SubmissionCardDiv>
                <SubmissionCardLeft
                  drawingShortId={submission.art_drawing_short_id}
                  displayName={getDisplayNameFromGobblerAuthAccount(
                    submission.recipient_user,
                    true,
                  )}
                  imgSrc={submission.drawing.base_64_image}
                  title={submission.drawing.artwork_title}
                  createdAt={submission.drawing.date_created}
                />
                <div style={{ flexGrow: 1, minWidth: 36 }} />
                <SubmissionCardImage src={imgSrc} />
              </SubmissionCardDiv>
              <MobileButtonsDiv>
                <Link
                  passHref={true}
                  href={{
                    pathname: '/drawing/[shortId]',
                    query: {
                      shortId: drawingShortId,
                    },
                  }}
                >
                  <PrimaryButton
                    as={'a'}
                    buttonSize="small"
                    type="button"
                    style={{ borderRadius: 30, width: 120 }}
                  >
                    View
                  </PrimaryButton>
                </Link>
                {/* <PrimaryButton
            as={'a'}
            buttonSize="small"
            type="button"
            buttonType="primary_white"
            style={{ borderRadius: 30, width: 120 }}
          >
            Reject
          </PrimaryButton> */}
              </MobileButtonsDiv>
            </SubmissionCardOuterContainer>
          )
        })}
    </DefaultLayout>
  )
}

export default Submissions
